import react from 'react'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useAuth} from '../../../../../app/modules/auth'
import {canUseTicketing} from '../../../../../app/modules/auth/core/ticketingAccess'
import {isMegaPay, isOnline, isOptional, onTSP, isTSP, URL} from '../../../../helpers'
import {getStuffIdSearchUrl} from '../../../../../app/modules/apps/stuffid-management/stuffidSite'
import {isOnPremisesInstallation} from '../../../../../app/modules/auth/core/onPremisesAccess'

export function MenuInner() {
  const {currentUser} = useAuth()
  const ticketingEnabled = canUseTicketing(currentUser)
  // The bank's own install has no ID page (the user, 2026-10-25).
  const showStuffIdPage = isMegaPay && !isOnPremisesInstallation(currentUser)
  return (
    <>
      <MenuItem title='داشبورد' to='/dashboard' />
      {(currentUser?.cpi || 0) == 0 && isOnline ? (
        <>
          <MenuItem title='خریداران' to='/apps/customer-management/customers' />
        </>
      ) : (
        <>
          <MenuItem title='صورتحساب‌های فروش' to='/apps/invoice-management/invoices' />
          {currentUser && !isOnPremisesInstallation(currentUser) && (
            <MenuItem title='صورتحساب‌های خرید' to='/apps/invoice-management/purchases' />
          )}
          <MenuItem title='خریداران' to='/apps/customer-management/customers' />
          <MenuItem title='کالاها/خدمات' to='/apps/product-management/products' />
        </>
      )}
      {showStuffIdPage && (
        <MenuItem
          title='شناسه‌های عمومی و اختصاصی'
          href={getStuffIdSearchUrl()}
          target='_blank'
        />
      )}
      {!isTSP && ticketingEnabled && <MenuItem title='تیکت' to='/apps/ticket-management' />}
      {onTSP && window.location.href.includes('sam') && (
        <MenuItem
          title={
            <>
              پشتیبانی{' '}
              <span className='text-left ms-3' dir='ltr'>
                021-51 72 1000
              </span>
            </>
          }
          href='tel:02151721000'
        />
      )}
      {onTSP && window.location.href.includes('ava') && (
        <MenuItem
          title={
            <>
              پشتیبانی{' '}
              <span className='text-left ms-3' dir='ltr'>
                021-910 800 80
              </span>
            </>
          }
          href='tel:02191080080'
        />
      )}
    </>
  )
}
